<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row aling-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Profile</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-form @submit.prevent="updateProfile">
          <b-row class="mt-4 align-items-center justify-content-around">
            <b-col sm="12" md="4" lg="3" xl="6">
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="text-center">
                    <b-card class="bg-light">
                      <b-avatar size="200px" :src="avatarSrc" class="mb-2">
                      </b-avatar>
                      <b-icon icon="info" class="avatar-edit" @click="setShowAvatarInfo"></b-icon>
                      <div v-if="showAvatarInfo" class="avatar-info" @click="setShowAvatarInfo">
                        Avatars are powered by Gravatar. If you want to change your avatar, please go to <a href="https://gravatar.com" target="_blank">Gravatar</a> and login or create an account to upload your custom profile picture.
                      </div>
                      <div class="mt-3 py-2 card mb-0">
                        <p class="h2">{{ usernameForm.toUpperCase() }}</p>
                        <p class="mb-0">{{ userGroupForm }}</p>
                      </div>
                    </b-card>
                  </b-col>
                </b-row>
            </b-col>
            <b-col md="6" lg="5">
              <div class="my-5 mx-2 d-flex flex-column items-center">

                <h6 class="heading-small text-muted mb-4">User information</h6>

                <validation-provider
                    name="user fullname"
                    :rules="{ required: false }"
                    v-slot="validationContext"
                    >
                      <p class="text-sm font-weight-700 mb-0">Full name</p>
                      <b-input-group id="name"  class="mb-4" >
                          <template #prepend>
                              <b-button variant="outline-light" disabled class="prepend-text-icon">
                                  <i class="fa fa-user text-dark-50"></i>
                              </b-button>
                          </template>
                          
                          <b-form-input
                              id="name"
                              name="name"
                              v-model="nameForm"
                              aria-describedby="name"
                              @blur="onBlur($event.target.id)"
                              :disabled="nameReadOnly"
                              :state="getNameValidationState(validationContext)"
                          ></b-form-input>
                          <template #append>
                            <b-button 
                                  v-if="nameReadOnly" 
                                  @click="nameReadOnly = !nameReadOnly"
                                  variant="outline-info" 
                                  >edit
                              </b-button>
                              <b-button 
                                  v-if="!nameReadOnly && getNameValidationState(validationContext)" 
                                  v-on:click="changeUserInfo('name', nameForm)" 
                                  :disabled="nameDisabled"
                                  :variant="nameDisabled? 'outline-info' : 'outline-success'" 
                                  >confirm
                              </b-button>
                          </template>
                          <b-form-invalid-feedback id="name">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-input-group>
                  </validation-provider>

                  <validation-provider
                      name="user email"
                      :rules="{ required: true, email: true }"
                      v-slot="validationContext"
                      >
                      <p class="text-sm font-weight-700 mb-0">Email address</p>
                      <b-input-group id="email" class="mb-4" >
                          <template #prepend>
                              <b-button variant="outline-light" disabled class="prepend-text-icon">
                                  <i class="fa fa-envelope text-dark-50"></i>
                              </b-button>
                          </template>
                          <b-form-input
                              id="email"
                              name="email"
                              v-model="emailForm"
                              aria-describedby="email"
                              @blur="onBlur($event.target.id)"
                              :disabled="emailReadOnly"
                              :state="getEmailValidationState(validationContext)"
                          ></b-form-input>
                          <template #append>
                            <b-button 
                                  v-if="emailReadOnly" 
                                  @click="emailReadOnly = !emailReadOnly"
                                  variant="outline-info" 
                                  >edit
                              </b-button>
                              <b-button 
                                  v-if="!emailReadOnly && getEmailValidationState(validationContext)" 
                                  v-on:click="changeUserInfo('email', emailForm)" 
                                  :disabled="emailDisabled"
                                  :variant="emailDisabled? 'outline-info' : 'outline-success'" 
                                  >confirm
                              </b-button>
                          </template>
                          <b-form-invalid-feedback id="email">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-input-group>
                  </validation-provider>

                  <validation-provider
                      name="phone number"
                      :rules="{ required: true, numeric: true }"
                      v-slot="validationContext"
                      >
                      <p class="text-sm font-weight-700 mb-0">Phone number</p>
                      <b-input-group id="phone" class="mb-0 phone-number-custom">
                          <vue-tel-input
                              v-model="phoneForm"
                              placeholder="201-555-2123"
                              class="mb-0 "
                              :defaultCountry="preferredCountry"
                              :enabledCountryCode="enabledCountryCodeStatus"
                              :state="getPhoneValidationState(validationContext)"
                              :validCharactersOnly="validCharactersOnly"
                              @country-changed="onSelect"
                              :disabled="phoneReadOnly"
                              @blur="onBlur('phone')"
                          ></vue-tel-input>
                          <template #append>
                              <b-button 
                                  v-if="phoneReadOnly" 
                                  @click="phoneReadOnly = !phoneReadOnly"
                                  variant="outline-info" 
                                  class="cursor-pointer">edit
                              </b-button>
                              <b-button 
                                  v-if="!phoneReadOnly && !phoneDisabled" 
                                  @click="changeUserInfo('phone_number', phoneForm)"
                                  :disabled="phoneDisabled"
                                  :variant="phoneDisabled? 'outline-info' : 'outline-success'" 
                                  >confirm
                              </b-button>
                          </template>
                            <!-- <b-form-invalid-feedback id="phone">{{ validationContext.errors[0] }}</b-form-invalid-feedback> -->
                          </b-input-group>
                          <b-form-invalid-feedback id="phone" class="mb-4 pt-0" :state="phoneStatus">Please enter a valid 11 digit phone number</b-form-invalid-feedback>
                  </validation-provider>

                  <validation-provider
                      name="password"
                      :rules="{ required: true, min: 7, regex: passwordFormat }"
                      v-slot="validationContext">
                      <p class="text-sm font-weight-700 mb-0">New Password</p>
                      <b-input-group id="password" class="mb-4 cursor-pointer">
                          <template #prepend>
                              <b-button class="prepend-text-icon" variant="outline-light" @click="setShowPassword">
                                  <i :class="showPassword? 'fa fa-eye-slash text-dark-50' : 'fa fa-eye text-dark-50'"></i>
                              </b-button>
                          </template>
                          <b-form-input
                              id="password"
                              name="password"
                              :type="showPassword ? 'text' : 'password'"
                              v-model="passwordForm"
                              aria-describedby="password"
                              @blur="onBlur($event.target.id)"
                              :disabled="passwordReadOnly"
                              :state="getPasswordValidationState(validationContext)"
                          ></b-form-input>
                          <template #append>
                            <b-button 
                                  v-if="passwordReadOnly" 
                                  @click="passwordReadOnly = !passwordReadOnly"
                                  variant="outline-info" 
                                  >edit
                              </b-button>
                              <b-button 
                                  v-if="!passwordReadOnly && getPasswordValidationState(validationContext)" 
                                  v-on:click="changePassword" 
                                  :disabled="!passwordStatus"
                                  :variant="!passwordStatus? 'outline-info' : 'outline-success'" 
                                  >confirm
                              </b-button>
                          </template>
                          <b-form-invalid-feedback v-if="!passwordLength">
                            Your password must have at least 8 chars.
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback v-if="!passwordUppercase">
                            Your password must have at least 1 upper case letter.
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback v-if="!passwordNumber">
                            Your password must have at least 1 number.
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback v-if="!passwordCharacter">
                            Your password must have at least 1 special char.
                          </b-form-invalid-feedback>
                      </b-input-group>
                  </validation-provider>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>
<script>
  import configDirective from "../../../common/directive/config-directive";
  import RouteBreadCrumb from '../../../components/Breadcrumb/RouteBreadcrumb';
  import VueCoreImageUpload from 'vue-core-image-upload';
  import { VueTelInput } from 'vue-tel-input';
  import 'vue-tel-input/dist/vue-tel-input.css';
  import {ValidationProvider} from 'vee-validate';
  import administrativeSerive from '../../../common/api-services/administrator-service'
  import md5 from "blueimp-md5";

  export default {
    components: {
      RouteBreadCrumb,
      VueCoreImageUpload,
      VueTelInput,
      ValidationProvider
    },
    computed: {
      config() {
         return {
        //   bucketName: 'myBucket',
        //   dirName: 'public-read',
        //   region: 'us-east-1',
        //   accessKeyId: 'AL3',
        //   secretAccessKey: 'xxxV5mDtRSRxJyOackGccY4va1KmHB+rFm9B++wd7Pr',
        //   s3Url: '' // TODO we need to update later
         }
      },
      // S3Client() {
      //   return new S3(this.config)
      // }
    },
    data() {
      return {
        accessToken: '',
        nameForm: '',
        emailForm: '',
        phoneForm: '',
        passwordForm: '',
        usernameForm: '',
        userGroupForm: '',
        currentUserValues: {},
        passwordFormat: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/,
        showPassword: false,
        hasImage: false,
        nameReadOnly: true,
        emailReadOnly: true,
        phoneReadOnly: true,
        passwordReadOnly: true,
        enabledCountryCodeStatus: true,
        preferredCountry: 'us',
        validCharactersOnly: true,
        dialCode: '',
        uploadAvatarStatus: false,
        showAvatarInfo: false,
        avatarSrc: '/img/theme/avatar4.png',
        images: [
          // {id: 1,  src: '/img/avatar/avatar1.png'},
          // {id: 2,  src: '/img/avatar/avatar2.png'},
          // {id: 3,  src: '/img/avatar/avatar3.png'},
          // {id: 4,  src: '/img/avatar/avatar4.png'},
          // {id: 5,  src: '/img/avatar/avatar5.png'},
          // {id: 6,  src: '/img/avatar/avatar6.png'},
          // {id: 7,  src: '/img/avatar/avatar7.png'},
          // {id: 8,  src: '/img/avatar/avatar8.png'},
          // {id: 9,  src: '/img/avatar/avatar9.png'},
          // {id: 10,  src: '/img/avatar/avatar10.png'},
          // {id: 11,  src: '/img/avatar/avatar11.png'},
          // {id: 13,  src: '/img/avatar/avatar13.png'},
          // {id: 14,  src: '/img/avatar/avatar14.png'},
          // {id: 15,  src: '/img/avatar/avatar15.png'},
          // {id: 16,  src: '/img/avatar/avatar16.png'},
          // {id: 17,  src: '/img/avatar/avatar17.png'},
          // {id: 18,  src: '/img/avatar/avatar18.png'},
          // {id: 19,  src: '/img/avatar/avatar19.png'},
          // {id: 20,  src: '/img/avatar/avatar20.png'},
          // {id: 21,  src: '/img/avatar/avatar21.png'},
          // {id: 22,  src: '/img/avatar/avatar22.png'},
          // {id: 23,  src: '/img/avatar/avatar23.png'},
          // {id: 24,  src: '/img/avatar/avatar24.png'},
          // {id: 25,  src: '/img/avatar/avatar25.png'},
          // {id: 26,  src: '/img/avatar/avatar26.png'}
        ]
      }
    },
    computed: {
      nameDisabled() {
        return this.nameForm === this.currentUserValues.name
      },
      emailDisabled() {
        return this.emailForm === this.currentUserValues.email
      },
      phoneDisabled() {
        if (this.phoneStatus === null) {
          return true
        } else {
          return !this.phoneStatus
        }
      },
      phoneStatus() {
        let scrubbedPhone = this.phoneForm.replaceAll(' ','').replaceAll('-','').replaceAll('(','').replaceAll(')','')
        let scrubbedCurrentPhone = ''
        if (this.currentUserValues.phone_number) {
          scrubbedCurrentPhone = this.currentUserValues.phone_number.replaceAll(' ','').replaceAll('-','').replaceAll('(','').replaceAll(')','')
        }

        if (scrubbedPhone === scrubbedCurrentPhone) {
          return null
        } else {
          return scrubbedPhone.replaceAll('+','').length === 11
        }
      },
      passwordStatus() {
        return !!(this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
      },
      passwordLength() {
        return this.passwordForm.length > 7
      },
      passwordUppercase() {
        let pass = this.passwordForm;
        for (let i = 0; i < pass.length; i++) {
          if ('A' <= pass[i] && pass[i] <= 'Z') {
            return true;
          }
        }
        return false;
      },
      passwordNumber() {
        let pass = this.passwordForm;
        for (let i = 0; i < pass.length; i++) {
          if ('0' <= pass[i] && pass[i] <= '9') {
            return true;
          }
        }
        return false;
      },
      passwordCharacter() {
        let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if (format.test(this.passwordForm)) {
          return true
        }
        return false;
      }
    },
    mounted() {
      document.title = 'Profile';
      this.getCustomerUserFunc();
      this.accessToken = sessionStorage.getItem('accessToken');
      this.getCustomerAvatarFunc();
    },

    methods: {
      selectAvatar(id) {
        this.images.map(item => {
          if (item.id === id) {
            this.avatarSrc = item.src;
          }
        })
      },

      getNameValidationState({ dirty, validated, valid = null }) {
        if (this.nameForm === this.currentUserValues.name) {
          return null;
        }
        return dirty || validated ? valid : null;
      },

      getEmailValidationState({ dirty, validated, valid = null }) {
        if (this.emailForm === this.currentUserValues.email) {
          return null;
        }
        return dirty || validated ? valid : null;
      },

      getPhoneValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },

      getPasswordValidationState({ dirty, validated, valid = null }) {
        if (this.passwordForm === '') {
          return null;
        }
        return dirty || validated ? valid : null;
      },

      getCustomerAvatarFunc() {
        let avatar = configDirective.getCustomerAvatar();
        // let avatar;
        let hash;
        if (this.emailForm.length > 0) {
          hash = md5(this.emailForm);
        } else {
          hash = md5("example@test.com");
        }
        avatar = "//www.gravatar.com/avatar/" + hash + "?r=g&d=retro";
        this.avatarSrc = avatar;
        if (avatar) {
          this.hasImage = true;
          this.uploadAvatarStatus = true;
          setTimeout(() => {
            this.$root.$emit('uploadImage', avatar);
          }, 300);
        }
      },

      setShowAvatarInfo() {
        this.showAvatarInfo = !this.showAvatarInfo;
      },

      getCustomerUserFunc() {
        let customerUser = configDirective.getCurrentUser();

        this.currentUserValues = customerUser;
        this.currentUserValues.access_token = customerUser.access_token.slice(0, 9);
        
        this.nameForm = customerUser.name;
        this.emailForm = customerUser.email;
        this.usernameForm = customerUser.username;
        this.phoneForm = customerUser.phone_number;
        this.userGroupForm = customerUser.groups[0];
        // this.passwordForm = customerUser.access_token.slice(0, 9)
        //this.avatarSrc = customerUser.avatarSrc;
      },

      setImage(output) {
        this.hasImage = true;
        this.image = output;
        this.uploadAvatarStatus = false;
        //console.log(output)
        setTimeout(() => {
          this.$root.$emit('uploadImage', output);
        }, 300);
        sessionStorage.setItem('avatar', output);
        //this.S3Client.uploadFile(output.info, 'new-name').then(data => console.log(data))
      },

      changeUserInfo(field, value) {
        const data=[{field, value}];
        if (field === 'phone_number') {
          data[0].value = data[0].value.replaceAll(' ', '');
        }
        administrativeSerive.updateUserProfile(this.usernameForm, data).then(res => {
          let errorCheck = !String(res.data.message).toLowerCase().includes('error');
          let failCheck = !String(res.data.message).toLowerCase().includes('fail');
          let nullCheck = !String(res.data.message).toLowerCase().includes('null');

          if (errorCheck && failCheck && nullCheck) {
            this.$toast.success(res.data.message);
            this.nameReadOnly = true;
            this.emailReadOnly = true;
            this.phoneReadOnly = true;
            this.passwordReadOnly = true;
            if (field === 'custom:avatar') {
              this.setImage(value)
            } 
            let updatedUser = {
              ...this.currentUserValues,
              [field]: value
            }
            if (field === 'email') {
              this.getCustomerAvatarFunc();
            }
            // set user updates to session storage
            sessionStorage.setItem("IOT_GetCurrentUser", JSON.stringify(updatedUser))
            this.getCustomerUserFunc();
          } else {
            this.$toast.error(res.data.message);
          }

        })
      },

      changePassword() {
        administrativeSerive.resetUserPassword(this.usernameForm, this.passwordForm).then(res => {
          if (String(res.data.message).toLowerCase().includes('error')) {
            this.passwordReadOnly = !this.passwordReadOnly;
            this.$toast.error(res.data.message);
          } else {
            this.passwordForm = '';
            this.passwordReadOnly = !this.passwordReadOnly;
            this.$toast.success(res.data.message);
          }
          // this.$toast(res.data.message)
        })
      },

      setShowPassword() {
        this.showPassword = !this.showPassword;
      },

      onBlur(id) {
        switch (id) {
          case "name":
            if (this.nameForm === '') {
              // this.nameForm = this.currentUserValues.name;
            }
            if (this.nameForm === this.currentUserValues.name) {
              this.nameReadOnly = true;
            }
            break;
          case "email":
            if (this.emailForm === '') {
              this.emailForm = this.currentUserValues.email;
            }
            if (this.emailForm === this.currentUserValues.email) {
              this.emailReadOnly = true;
            }
            break;
          case "phone":
            if (this.phoneForm === '') {
              this.phoneForm = this.currentUserValues.phone_number;
            }
            if (this.phoneForm === this.currentUserValues.phone_number) {
              this.phoneReadOnly = true;
            }
            break;
          case "password":
            if (this.passwordForm === this.currentUserValues.access_token.slice(0, 9)) {
              this.passwordReadOnly = true;
            } else if (this.passwordForm === '') {
              this.passwordReadOnly = true;
            }
            break;
          default:
            console.log("UserProfile switch default")
            break;
        }
      },

      onSelect({name, iso2, dialCode}) {
        this.dialCode = dialCode
      },
    }
  };
</script>

<style scoped>
.avatar-edit {
  position: absolute;
  top: 50px;
  right: 40px;
  font-size: 1.6rem;
  cursor: pointer;
  color: #212529;
  background-color: #fff;
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}

.avatar-info {
  position: absolute;
  top: 50px;
  right: 5px;
  left: 5px;
  cursor: pointer;
  color:#fff;
  background-color: rgba(0, 0, 0, 0.65);
  font-size: 0.8rem;
  border-radius: 5px;
  padding: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
</style>